import { render } from "./OrderProductFileModal.vue?vue&type=template&id=ff2f104e"
import script from "./OrderProductFileModal.vue?vue&type=script&lang=js"
export * from "./OrderProductFileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__